import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsSection = () => {
  const statsData = [
    { label: "Active Users", value: "1,000+", icon: "Users" },
    { label: "Transactions Processed", value: "$1+", icon: "DollarSign" },
    { label: "Energy Saved", value: "2M kWh", icon: "Zap" },
    { label: "Developers Mentored", value: "100+", icon: "GraduationCap" },
  ];

  return (
    <section className="py-16 bg-gradient-to-r from-primary to-accent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Impact by Numbers
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Measurable results from projects that make a real difference in users' lives.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={stat.icon} size={24} className="text-white" />
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-2">{stat.value}</div>
              <div className="text-white/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;